export default [
    {
        key:"pages",//this key will be pass by the main table. this is to identify which table setttings to load
        label: "Page Permissions",
        icon: "icon-folder",
        tableSettings: {
            route: "pages",
            postEndpoint: "addMultipleMyPages",//after user selected multiple items, this enpoint will be use to save the items to db
            formType: "sidebarRightSide",
            addBtnLabel: "Add Selected Pages", 
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                // pkId: "", 
            },
            filterEndpoint: "myPages",
            showAddBtn: true,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
        },
    },
    
]